import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import Base from './Base'

export class NavMenu extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            menuOpen: 1,
        }
    }
    toggleMenu(menu) {
        if (this.state.openMenu == menu) {
            if (this.state.openMenu.substr(0, 4) == "mgr_")
                this.setState({ openMenu: 'mgr' });
            else
                this.setState({ openMenu: '' });
        }
        else this.setState({ openMenu: menu });
    }
    componentDidMount() {
        this.httpPost("/api/v1/common/get/", {
            id: this.getCurrentFormId()
        })
            .then(res => {
                window.scrollTo(0, 0);
                if (this.isNull(res)) return;
                if (!this.isBlank(res.redirectTo)) this.setState({ redirect: res.redirectTo });
                else {
                    if (res.status === 1) this.setState({ data: res });
                    else this.showErorr(res.message);
                }
            });
    }
    toggleSideBar() {
        //document.getElementsByName('body').classList.add('nk-body bg-lighter npc-general has-sidebar has-rtl has-touch as-mobile nk-nio-theme nav-shown');
        if (document.getElementById('sideBarMenu').classList.contains("nk-sidebar-active"))
            document.getElementById('sideBarMenu').classList.remove('nk-sidebar-active');
        else
            document.getElementById('sideBarMenu').classList.add('nk-sidebar-active');
    }
    render() {
        if (this.isNull(this.state.data)) return null;

        return <div className="nk-sidebar nk-sidebar-fixed is-dark " id="sideBarMenu" data-content="sidebarMenu">
            <div className="nk-sidebar-element nk-sidebar-head">
                <div className="nk-menu-trigger" onClick={(e) => this.toggleSideBar()}>
                    <a className="nk-nav-toggle nk-quick-nav-icon d-xl-none" data-target="sidebarMenu">
                        <em className="icon ni ni-arrow-left"></em>
                    </a>
                </div>
            </div>
            <div className="nk-sidebar-element nk-sidebar-body">
                <div className="nk-sidebar-content">
                    <div className="nk-sidebar-menu" data-simplebar>
                        <ul className="nk-menu">
                            <li className="nk-menu-item">
                                <Link to="/dashboard/" className="nk-menu-link">
                                    <span className="nk-menu-text text-white">داشبرد</span>
                                </Link>
                            </li>
                            {this.hasPermission(1) && <li className={"nk-menu-item has-sub " + (this.state.openMenu == "news" ? "active" : "")}>
                                <a className="hand nk-menu-link nk-menu-toggle" onClick={e => this.toggleMenu('news')}>
                                    <span className="nk-menu-text text-white">اخبار</span>
                                </a>
                                <ul className="nk-menu-sub">
                                    {this.hasPermission(19) && <Link to="/news/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">همه اخبار</span>
                                    </Link>}
                                    {this.hasPermission(20) && <Link to="/news/new/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">خبر جدید</span>
                                    </Link>}
                                    {this.hasPermission(21) && <Link to="/newscategories/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">دسته ها</span>
                                    </Link>}
                                </ul>
                            </li>}
                            {this.hasPermission(2) && <li className={"nk-menu-item has-sub " + (this.state.openMenu == "blog" ? "active" : "")}>
                                <a className="hand nk-menu-link nk-menu-toggle" onClick={e => this.toggleMenu('blog')}>
                                    <span className="nk-menu-text text-white">مقالات</span>
                                </a>
                                <ul className="nk-menu-sub">
                                    {this.hasPermission(22) && <Link to="/blogs/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">همه مقالات</span>
                                    </Link>}
                                    {this.hasPermission(23) && <Link to="/blogs/new/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">مقاله جدید</span>
                                    </Link>}
                                    {this.hasPermission(24) && <Link to="/blogcategories/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">دسته ها</span>
                                    </Link>}
                                </ul>
                            </li>}
                            {this.hasPermission(94) && <li className={"nk-menu-item has-sub " + (this.state.openMenu == "minutes" ? "active" : "")}>
                                <a className="hand nk-menu-link nk-menu-toggle" onClick={e => this.toggleMenu('minutes')}>
                                    <span className="nk-menu-text text-white">صورتجلسات</span>
                                </a>
                                <ul className="nk-menu-sub">
                                    {this.hasPermission(95) && <Link to="/minutes/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">همه صورتجلسات</span>
                                    </Link>}
                                    {this.hasPermission(96) && <Link to="/minutes/new/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">صورتجلسه جدید</span>
                                    </Link>}
                                    {this.hasPermission(101) && <Link to="/minutes/categories/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">دسته ها</span>
                                    </Link>}
                                </ul>
                            </li>}
                            {this.hasPermission(97) && <li className={"nk-menu-item has-sub " + (this.state.openMenu == "projects" ? "active" : "")}>
                                <a className="hand nk-menu-link nk-menu-toggle" onClick={e => this.toggleMenu('projects')}>
                                    <span className="nk-menu-text text-white">پروژه ها</span>
                                </a>
                                <ul className="nk-menu-sub">
                                    {this.hasPermission(98) && <Link to="/projects/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">همه پروژه ها</span>
                                    </Link>}
                                    {this.hasPermission(99) && <Link to="/projects/new/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">پروژه جدید</span>
                                    </Link>}
                                    {this.hasPermission(100) && <Link to="/projects/categories/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">دسته ها</span>
                                    </Link>}
                                </ul>
                            </li>}
                            {this.hasPermission(102) && <li className={"nk-menu-item has-sub " + (this.state.openMenu == "meetings" ? "active" : "")}>
                                <a className="hand nk-menu-link nk-menu-toggle" onClick={e => this.toggleMenu('meetings')}>
                                    <span className="nk-menu-text text-white">جلسات</span>
                                </a>
                                <ul className="nk-menu-sub">
                                    {this.hasPermission(103) && <Link to="/meetings/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">همه جلسات</span>
                                    </Link>}
                                    {this.hasPermission(104) && <Link to="/meetings/new/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">جلسه جدید</span>
                                    </Link>}
                                </ul>
                            </li>}
                            {this.hasPermission(106) && <li className={"nk-menu-item has-sub " + (this.state.openMenu == "resumes" ? "active" : "")}>
                                <a className="hand nk-menu-link nk-menu-toggle" onClick={e => this.toggleMenu('resumes')}>
                                    <span className="nk-menu-text text-white">رزومه ها</span>
                                </a>
                                <ul className="nk-menu-sub">
                                    {this.hasPermission(107) && <Link to="/resumes/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">همه رزومه ها</span>
                                    </Link>}
                                    {this.hasPermission(108) && <Link to="/resumes/new/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">رزومه جدید</span>
                                    </Link>}
                                </ul>
                            </li>}
                            {this.hasPermission(3) && <li className={"nk-menu-item has-sub " + (this.state.openMenu == "shops" ? "active" : "")}>
                                <a className="hand nk-menu-link nk-menu-toggle" onClick={e => this.toggleMenu('shops')}>
                                    <span className="nk-menu-text text-white">فروشگاه</span>
                                </a>
                                <ul className="nk-menu-sub">
                                    {this.hasPermission(25) && <Link to="/shop/orders/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">سفارشات فروشگاه</span>
                                    </Link>}
                                    {this.hasPermission(26) && <Link to="/shop/payments/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">پرداختها</span>
                                    </Link>}
                                    {this.hasPermission(27) && <Link to="/shop/products/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">همه محصولات</span>
                                    </Link>}
                                    {this.hasPermission(28) && <Link to="/shop/products/new/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">محصول جدید</span>
                                    </Link>}
                                    {this.hasPermission(48) && <Link to="/shop/fast/update/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">ویرایش سریع</span>
                                    </Link>}
                                    {this.hasPermission(29) && <Link to="/shop/categories/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">دسته ها</span>
                                    </Link>}
                                    {this.hasPermission(30) && <Link to="/shop/brands/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">برند ها</span>
                                    </Link>}
                                    {this.hasPermission(31) && <Link to="/shop/tags/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">برچسب ها</span>
                                    </Link>}
                                    {this.hasPermission(32) && <Link to="/shop/attributes/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">ویژگی ها</span>
                                    </Link>}
                                    {this.hasPermission(33) && <Link to="/shop/stores/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">فروشگاه/نمایندگی</span>
                                    </Link>}
                                    {this.hasPermission(34) && <Link to="/shop/stores/categories/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">دسته بندی فروشگاه ها</span>
                                    </Link>}


                                    {this.hasPermission(44) && <Link to="/shop/guarantees/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">گارانتی</span>
                                    </Link>}
                                    {this.hasPermission(45) && <Link to="/shop/shipmentmethods/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">روش های ارسال</span>
                                    </Link>}
                                    {this.hasPermission(46) && <Link to="/shop/insurancerates/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">نرخهای بیمه</span>
                                    </Link>}
                                    {this.hasPermission(47) && <Link to="/shop/shippingzones/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">هزینه نواحی پستی</span>
                                    </Link>}
                                </ul>
                            </li>}
                            {this.hasPermission(4) && <li className={"nk-menu-item has-sub " + (this.state.openMenu == "services" ? "active" : "")}>
                                <a className="hand nk-menu-link nk-menu-toggle" onClick={e => this.toggleMenu('services')}>
                                    <span className="nk-menu-text text-white">خدمات</span>
                                </a>
                                <ul className="nk-menu-sub">
                                    {this.hasPermission(36) && <Link to="/services/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">همه خدمات</span>
                                    </Link>}
                                    {this.hasPermission(37) && <Link to="/services/new/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">خدمت جدید</span>
                                    </Link>}
                                    {this.hasPermission(38) && <Link to="/servicecategories/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">دسته ها</span>
                                    </Link>}
                                </ul>
                            </li>}
                            {this.hasPermission(5) && <li className={"nk-menu-item has-sub " + (this.state.openMenu == "products" ? "active" : "")}>
                                <a className="hand nk-menu-link nk-menu-toggle" onClick={e => this.toggleMenu('products')}>
                                    <span className="nk-menu-text text-white">کاتالوگ محصولات</span>
                                </a>
                                <ul className="nk-menu-sub">
                                    {this.hasPermission(39) && <Link to="/products/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">همه محصولات</span>
                                    </Link>}
                                    {this.hasPermission(40) && <Link to="/products/new/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">محصول جدید</span>
                                    </Link>}
                                    {this.hasPermission(41) && <Link to="/productcategories/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">دسته ها</span>
                                    </Link>}
                                </ul>
                            </li>}

                            {this.hasPermission(49) && <li className={"nk-menu-item has-sub " + (this.state.openMenu == "goldStore" ? "active" : "")}>
                                <a className="hand nk-menu-link nk-menu-toggle" onClick={e => this.toggleMenu('goldStore')}>
                                    <span className="nk-menu-text text-white">سیستم معاملات</span>
                                </a>
                                <ul className="nk-menu-sub">
                                    {this.hasPermission(75) && <li className="nk-menu-item">
                                        <Link to="/deposits/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">درخواستهای واریز</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission(78) && <Link to="/goldstore/orders/" className="nk-menu-link">
                                        <span className="nk-menu-text text-white">سفارشات معاملاتی</span>
                                    </Link>}
                                    {this.hasPermission(50) && <li className="nk-menu-item">
                                        <Link to="/customergrouprates/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">تعرفه گروه ها</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission(51) && <li className="nk-menu-item">
                                        <Link to="/symbols/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">نمادهای معاملاتی</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission(52) && <li className="nk-menu-item">
                                        <Link to="/timing/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">ساعات معاملاتی</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission(74) && <li className="nk-menu-item">
                                        <Link to="/bankaccounts/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">حسابهای بانکی</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission(76) && <li className="nk-menu-item">
                                        <Link to="/goldstoresettings/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">تنظیمات تخصصی</span>
                                        </Link>
                                    </li>}
                                </ul>
                            </li>}

                            {this.hasPermission(53) && <li className={"nk-menu-item has-sub " + (this.state.openMenu == "stone" ? "active" : "")}>
                                <a className="hand nk-menu-link nk-menu-toggle" onClick={e => this.toggleMenu('stone')}>
                                    <span className="nk-menu-text text-white">سیستم شناسنامه</span>
                                </a>
                                <ul className="nk-menu-sub">
                                    {this.hasPermission(54) && this.state.data.global.stoneTemplates.map(item =>
                                        item.type === 1 && <li className="nk-menu-item">
                                            <a href={"/profile/stones/" + item.id + "/"} className="nk-menu-link">
                                                <span className="nk-menu-text text-white">{item.title}</span>
                                            </a>
                                        </li>
                                    )}
                                    {this.hasPermission(55) && <li className="nk-menu-item">
                                        <NavLink to="/stones/report/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">گزارش ارسال سنگ</span>
                                        </NavLink>
                                    </li>}

                                    {this.hasPermission(56) && this.state.data.global.stoneTemplates.map(item =>
                                        item.type === 2 && <li className="nk-menu-item">
                                            <a href={"/profile/luxurious/" + item.id + "/"} className="nk-menu-link">
                                                <span className="nk-menu-text text-white">{item.title}</span>
                                            </a>
                                        </li>
                                    )}
                                    {this.hasPermission(57) && <li className="nk-menu-item">
                                        <NavLink to="/luxurious/report/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">گزارش ارسال فاخر</span>
                                        </NavLink>
                                    </li>}

                                    {this.hasPermission(87) && this.state.data.global.stoneTemplates.map(item =>
                                        item.type === 3 && <li className="nk-menu-item">
                                            <a href={"/profile/shemshes/" + item.id + "/"} className="nk-menu-link">
                                                <span className="nk-menu-text text-white">{item.title}</span>
                                            </a>
                                        </li>
                                    )}

                                    {this.hasPermission(88) && this.state.data.global.stoneTemplates.map(item =>
                                        item.type === 4 &&<li className="nk-menu-item">
                                            <a href={"/profile/sachmes/" + item.id + "/"} className="nk-menu-link">
                                                <span className="nk-menu-text text-white">{item.title}</span>
                                            </a>
                                        </li>
                                    )}

                                    {this.hasPermission(58) && <li className="nk-menu-item">
                                        <Link to="/requests/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">درخواست شناسنامه</span>
                                        </Link>
                                    </li>}

                                    {this.hasPermission(71) && <li className="nk-menu-item">
                                        <Link to="/applicants/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">مشتریان</span>
                                        </Link>
                                    </li>}

                                    {this.hasPermission(59) && <li className="nk-menu-item">
                                        <Link to="/websites/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">وبسایتها</span>
                                        </Link>
                                    </li>}

                                    {this.hasPermission(60) && <li className="nk-menu-item">
                                        <Link to="/stonetemplates/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">الگوهای شناسنامه</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission(61) && <li className="nk-menu-item">
                                        <Link to="/colors/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">رنگها</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission(62) && <li className="nk-menu-item">
                                        <Link to="/sizes/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">ابعاد</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission(63) && <li className="nk-menu-item">
                                        <Link to="/weights/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">وزنها</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission(64) && <li className="nk-menu-item">
                                        <Link to="/kinds/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">انواع تراش</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission(65) && <li className="nk-menu-item">
                                        <Link to="/types/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">انواع سنگ</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission(66) && <li className="nk-menu-item">
                                        <Link to="/stufftypes/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">انواع کالاها</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission(67) && <li className="nk-menu-item">
                                        <Link to="/jenses/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">جنس کالاها</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission(68) && <li className="nk-menu-item">
                                        <Link to="/rings/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">سایز رینگ</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission(69) && <li className="nk-menu-item">
                                        <Link to="/transparency/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">شفافیت</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission(70) && <li className="nk-menu-item">
                                        <Link to="/origins/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">منشا</span>
                                        </Link>
                                    </li>}
                                </ul>
                            </li>}

                            {this.hasPermission(79) && <li className={"nk-menu-item has-sub " + (this.state.openMenu == "acc" ? "active" : "")}>
                                <a className="hand nk-menu-link nk-menu-toggle" onClick={e => this.toggleMenu('acc')}>
                                    <span className="nk-menu-text text-white">حسابداری</span>
                                </a>
                                <ul className="nk-menu-sub">
                                    {this.hasPermission(80) && <li className="nk-menu-item">
                                        <Link to="/factors/sale/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">فاکتورهای فروش</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission(81) && <li className="nk-menu-item">
                                        <Link to="/factors/buy/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">فاکتورهای خرید</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission(89) && <li className="nk-menu-item">
                                        <Link to="/remittances/in" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">رسیدهای انبار</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission(90) && <li className="nk-menu-item">
                                        <Link to="/remittances/out" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">حواله های انبار</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission(91) && <li className="nk-menu-item">
                                        <Link to="/remittances/transfer" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">جابجایی کالا</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission(92) && <li className="nk-menu-item">
                                        <Link to="/stuff/cardex" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">کارتکس کالا</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission(82) && <li className="nk-menu-item">
                                        <Link to="/factors/salereturn/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">فاکتورهای برگشت از فروش</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission(83) && <li className="nk-menu-item">
                                        <Link to="/factors/buyreturn/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">فاکتورهای برگشت از خرید</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission(84) && <li className="nk-menu-item">
                                        <Link to="/receipts/in/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">رسیدهای دریافت</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission(85) && <li className="nk-menu-item">
                                        <Link to="/receipts/out/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">رسیدهای پرداخت</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission(86) && <li className="nk-menu-item">
                                        <Link to="/cashdesks/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">صندوق ها</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission(93) && <li className="nk-menu-item">
                                        <Link to="/warehouses/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">انبارها</span>
                                        </Link>
                                    </li>}
                                </ul>
                            </li>}
                            {this.hasPermission(73) && <li className={"nk-menu-item has-sub " + (this.state.openMenu == "site" ? "active" : "")}>
                                <a className="hand nk-menu-link nk-menu-toggle" onClick={e => this.toggleMenu('site')}>
                                    <span className="nk-menu-text text-white">طراحی سایت</span>
                                </a>
                                <ul className="nk-menu-sub">

                                    {this.hasPermission(6) && <li className="nk-menu-item">
                                        <Link to="/magazines/" className="nk-menu-link">

                                            <span className="nk-menu-text text-white">مجلات</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission(7) && <li className="nk-menu-item">
                                        <Link to="/pages/" className="nk-menu-link">

                                            <span className="nk-menu-text text-white">صفحات</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission(42) && <li className="nk-menu-item">
                                        <Link to="/forms/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">فرم ها</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission(8) && <li className="nk-menu-item">
                                        <Link to="/ads/" className="nk-menu-link">

                                            <span className="nk-menu-text text-white">تبلیغات</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission(10) && <li className="nk-menu-item">
                                        <Link to="/sliders/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">اسلایدرها</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission(11) && <li className="nk-menu-item">
                                        <Link to="/menus/" className="nk-menu-link">

                                            <span className="nk-menu-text text-white">منوها</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission(17) && <li className="nk-menu-item">
                                        <Link to="/tags/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">برچسب ها</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission(12) && <li className="nk-menu-item">
                                        <Link to="/redirects/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">ریدایرکت صفحات</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission(14) && <li className="nk-menu-item">
                                        <Link to="/comments/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">نظرات</span>
                                        </Link>
                                    </li>}

                                    {this.hasPermission(43) && <li className="nk-menu-item">
                                        <Link to="/templates/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">تمپلیتهای قالب</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission(16) && <li className="nk-menu-item">
                                        <Link to="/moduledesginer/" className="nk-menu-link">
                                            <span className="nk-menu-text text-white">طراحی ماژولها و صفحات</span>
                                        </Link>
                                    </li>}
                                </ul>
                            </li>}

                            {this.hasPermission(105) && <li className="nk-menu-item">
                                <Link to="/chats/" className="nk-menu-link">
                                    <span className="nk-menu-text text-white">پیامهای پشتیبانی</span>
                                </Link>
                            </li>}

                            {this.hasPermission(9) && <li className="nk-menu-item">
                                <Link to="/customers/" className="nk-menu-link">
                                    <span className="nk-menu-text text-white">مشتریان</span>
                                </Link>
                            </li>}

                            {this.state.data.global.user.userRole == 1 && <li className="nk-menu-item">
                                <Link to="/users/" className="nk-menu-link">

                                    <span className="nk-menu-text text-white">مدیران / کاربران</span>
                                </Link>
                            </li>}
                            {this.hasPermission(13) && <li className="nk-menu-item">
                                <Link to="/settings/" className="nk-menu-link">
                                    <span className="nk-menu-text text-white">تنظیمات</span>
                                </Link>
                            </li>}

                            {this.hasPermission(18) && <li className="nk-menu-item">
                                <Link to="/usergroups/" className="nk-menu-link">
                                    <span className="nk-menu-text text-white">گروه های کاربری</span>
                                </Link>
                            </li>}
                            {this.hasPermission(48) && <li className="nk-menu-item">
                                <Link to="/customergroups/" className="nk-menu-link">
                                    <span className="nk-menu-text text-white">گروه های مشتریان</span>
                                </Link>
                            </li>}
                            {this.hasPermission(72) && <li className="nk-menu-item">
                                <Link to="/pricegroups/" className="nk-menu-link">
                                    <span className="nk-menu-text text-white">گروه های قیمتی</span>
                                </Link>
                            </li>}

                            {this.hasPermission(15) && <li className="nk-menu-item">
                                <Link to="/fm/" className="nk-menu-link">

                                    <span className="nk-menu-text text-white">مدیریت فایل</span>
                                </Link>
                            </li>}
                            <li className="nk-menu-item">
                                <Link to="/profile/" className="nk-menu-link">

                                    <span className="nk-menu-text text-white">پروفایل</span>
                                </Link>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>
    }
}